import { createContext, useContext, type ReactNode } from "react";

export type FeatureFlags = {
  isDealerGeneratedAppEnabled: boolean;
};

export const defaultFeatureFlags: FeatureFlags = {
  isDealerGeneratedAppEnabled: false,
};

export const FeatureFlagsContext =
  createContext<FeatureFlags>(defaultFeatureFlags);

export const FeatureFlagsProvider = ({
  children,
  featureFlags,
}: {
  children: ReactNode;
  featureFlags: FeatureFlags;
}) => (
  <FeatureFlagsContext.Provider value={featureFlags}>
    {children}
  </FeatureFlagsContext.Provider>
);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
